"use client";

import { c as _c } from "react/compiler-runtime";
import MovieMeta from "./MovieMeta";
import MovieActions from "./MovieActions";
import GenreTags from "../_shared/GenreTags";
import LikedPercent from "../_shared/LikedPercent";
import type { Movie, Tag } from "@/types/movies";
import type { BackgroundImages } from "../_shared/contentMeta";
interface Props {
  movie: Movie;
  images: BackgroundImages;
  year: string;
  countries: Tag[];
  genres: Tag[];
  subtitles: string;
  durationLabel: string;
  hasActiveSubscription: boolean;
  hasActiveTicket: boolean;
  onBuyClick: () => void;
}
export default function MovieMobileMeta(t0) {
  const $ = _c(23);
  const {
    movie,
    images,
    year,
    countries,
    genres,
    subtitles,
    durationLabel,
    hasActiveSubscription,
    hasActiveTicket,
    onBuyClick
  } = t0;
  const t1 = movie?.age_restriction?.name || "";
  const t2 = String(movie?.imdb_rate ?? "");
  let t3;
  if ($[0] !== countries || $[1] !== durationLabel || $[2] !== subtitles || $[3] !== t1 || $[4] !== t2 || $[5] !== year) {
    t3 = <div className="w-full block lg:hidden"><MovieMeta ageLimit={t1} seasons={durationLabel} year={year} rating={t2} countries={countries} subtitles={subtitles} /></div>;
    $[0] = countries;
    $[1] = durationLabel;
    $[2] = subtitles;
    $[3] = t1;
    $[4] = t2;
    $[5] = year;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== genres) {
    t4 = <GenreTags tags={genres} className="flex lg:hidden mt-4 md:mt-6" />;
    $[7] = genres;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = movie?.trailers?.[0]?.uuid || "";
  const t6 = movie?.content_access || "";
  const t7 = movie?.uuid || "";
  const t8 = movie?.title_fa || movie?.title_en || "";
  const t9 = movie?.coming_soon;
  let t10;
  if ($[9] !== hasActiveSubscription || $[10] !== hasActiveTicket || $[11] !== images || $[12] !== onBuyClick || $[13] !== t5 || $[14] !== t6 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <div className="w-full block lg:hidden"><MovieActions traileruuid={t5} status={t6} poster={images} uuid={t7} title={t8} onBuyClick={onBuyClick} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} comingSoon={t9} /></div>;
    $[9] = hasActiveSubscription;
    $[10] = hasActiveTicket;
    $[11] = images;
    $[12] = onBuyClick;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3 || $[21] !== t4) {
    t11 = <>{t3}{t4}{t10}</>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t4;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}